module.exports = __webpack_public_path__ + "img/app_downlaod.53b43e85.png";